import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const LoadingSplash = ({ 
  message = "Loading...", 
  icon = "Loader2", 
  showProgress = false, 
  progress = 0,
  fullScreen = false,
  delay = 0 
}) => {
  const [show, setShow] = React.useState(delay === 0);

  React.useEffect(() => {
    if (delay > 0) {
      const timer = setTimeout(() => setShow(true), delay);
      return () => clearTimeout(timer);
    }
  }, [delay]);

  if (!show) return null;

  const containerClasses = fullScreen 
    ? "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm flex items-center justify-center"
    : "flex items-center justify-center p-8";

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center space-y-4 text-center max-w-sm">
        {/* Animated Icon */}
        <div className="relative">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center animate-pulse">
            <Icon 
              name={icon} 
              size={24} 
              className="text-primary animate-spin" 
            />
          </div>
          
          {/* Outer ring animation */}
          <div className="absolute inset-0 w-16 h-16 border-2 border-primary/20 rounded-full animate-ping"></div>
        </div>

        {/* Loading Message */}
        <div className="space-y-2">
          <h3 className="text-lg font-medium text-foreground">{message}</h3>
          
          {/* Progress Bar */}
          {showProgress && (
            <div className="w-48 h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className="h-full bg-primary transition-all duration-300 ease-out rounded-full"
                style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
              />
            </div>
          )}
          
          {/* Loading dots animation */}
          <div className="flex justify-center space-x-1">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSplash;